export default __webpack_public_path__ + "static/media/x.2b903bf9.svg";